import { ApiResponse, ShiftDetail } from '@packages/database/types';
import api from './client/axios';

export const toggleShift = async (): Promise<ShiftDetail> => {
  const response = await api.post<ApiResponse<ShiftDetail>>('/shifts/toggle');
  return response.data.data!;
};

export const getActiveShift = async (): Promise<ShiftDetail> => {
  const response = await api.get<ApiResponse<ShiftDetail>>('/shifts/active');
  return response.data.data!;
};
